<template>
  <div>
    <v-container class="py-0 mb-8">
      <v-row no-gutters>
        <!-- v-if="!$store.state.mobile" -->
        <v-col
          :cols="$store.state.mobile ? '12' : 'auto'"
          class="me-1"
        >
          <div
            v-if="!$store.state.mobile"
            :style="$store.state.mobile ? '' : 'width:240px'"
            class="pt-3"
          >
            <v-card
              v-for="item in infoList.data"
              :key="item.categoryId"
              outlined
              tile
              class="mb-4"
            >
              <v-card-title class="headline black--text font-medium">
                {{ $store.getters.languageGetter === '1' ? item.categoryName : item.categoryNameEn }}
              </v-card-title>
              <v-divider />
              <div class="pa-4">
                <div
                  v-for="subitem in item.child"
                  :key="subitem.id"
                  class="mb-2 subinfo"
                  :class="subitem.dnames === $route.params.title ? 'active' : ''"
                >
                  <router-link :to="{name: 'InformationContent', params: {id: subitem.id, title: $store.getters.languageGetter === '1' ? subitem.dnames : subitem.dnamesEn}}">
                    {{ $store.getters.languageGetter === '1' ? subitem.dnames : subitem.dnamesEn }}
                  </router-link>
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
        <v-col>
          <router-view />
        </v-col>
      </v-row>
    </v-container>
    <news-letter />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import NewsLetter from '@/layout/NewsLetter.vue';

export default {
  name: 'Information',
  components: {
    NewsLetter,
  },
  computed: {
    ...mapState('information', ['infoList']),
  },
  created() {
    this.getInfoListAsync();
  },
  methods: {
    ...mapActions('information', ['getInfoListAsync']),
  },
};
</script>

<style lang="scss" scoped>
.subinfo {
  position: relative;
  transition: all 0.2s ease-in-out;

  &::before {
    content: '°';
    position: absolute;
    top: 8px;
    transform: scale(2);
    left: 0;
    margin-top: -2px;
    color: #999;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }

  &.active {
    padding-left: 10px;
    font-weight: bold;

    &::before {
      opacity: 1;
      font-weight: normal;
    }
  }

  &:hover {
    padding-left: 10px;
    font-weight: bold;

    &::before {
      opacity: 1;
      font-weight: normal;
    }
  }
}
</style>
